import { ApolloClient, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';

const api = createUploadLink({
  uri: import.meta.env.VITE_APP_API_GRAPHQL_URL,
  headers: {
    'Apollo-Require-Preflight': 'true',
  },
});

const authLink = setContext(async (_, { headers }) => {
  let token: string | null = null;

  try {
    // get the authentication token from local storage if it exists
    token = localStorage.getItem('local:token');
  } catch (e) {
    console.error('Error getting token from storage', e);
  }
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(api),
  cache: new InMemoryCache(),
});

export default client;
